import React, { useMemo } from 'react';
import { BsPlusCircle } from 'react-icons/bs';
import { Box, Flex, GridItem, Icon, IconButton, VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import GridRow from '../../../../../../../../../../components/GridRow';
import LoadingSpinner from '../../../../../../../../../../components/Spinner';
import { analyticsIds } from '../../../../../../../../../../constants/analyticsIds';
import { useAttachmentUploader } from '../../../../../../../../../../services/attachment-service';
import { useRecordAttachments } from '../../../../../../../../../../services/record-service';

import FileNameCell from './cells/FileNameCell';
import UploadDateCell from './cells/UploadDateCell';

const AttachmentsTable = ({ recordId }) => {
  const { data, isLoading } = useRecordAttachments(recordId);
  const handleAttachmentUpload = useAttachmentUploader(recordId);

  const activeAttachments = useMemo(() => {
    if (isLoading) {
      return [];
    }

    return data.filter(attachment => !!attachment.url && attachment.status !== 'archived' && attachment.status !== 'deleted');
  }, [data, isLoading]);

  if (isLoading) {
    return (
      <Box>
        <LoadingSpinner isInline minHeight="150px" />
      </Box>
    );
  }

  return (
    <VStack width="100%">
      <GridRow bgColor="greyScale.100" py={3} textStyle="bodySm600">
        <GridItem alignSelf="center" colSpan={1} justifySelf="center">
          <IconButton
            aria-label="upload document"
            data-analytics-id={analyticsIds.insuredProfilePage.attachmentsComponent.uploadAttachmentButton}
            icon={<Icon as={BsPlusCircle} boxSize={4} cursor="pointer" />}
            variant="textPrimary"
            onClick={handleAttachmentUpload}
          />
        </GridItem>
        <GridItem alignSelf="center" colSpan={5} justifySelf="center">File Name</GridItem>
        <GridItem alignSelf="center" colSpan={4} justifySelf="center">Upload Date</GridItem>
      </GridRow>

      {activeAttachments.length > 0
        ? (
          <>
            {activeAttachments.map(attachment => (
              <Box
                _even={{ bg: 'white' }}
                _odd={{ bg: 'greyScale.100' }}
                key={attachment.id}
                marginTop="0 !important"
                maxHeight="400px"
                overflowY="auto"
                width="100%"
              >
                <GridRow sticky>
                  <GridItem colSpan={1}>
                    <Box />
                  </GridItem>
                  <GridItem alignSelf="center" colSpan={5} justifySelf="center">
                    <FileNameCell attachment={attachment} recordId={recordId} />
                  </GridItem>
                  <GridItem alignSelf="center" colSpan={4} justifySelf="center">
                    <UploadDateCell attachment={attachment} />
                  </GridItem>
                </GridRow>
              </Box>
            ))}
          </>
        ) : (
          <Flex
            alignItems="center"
            color="greyScale.700"
            height="175"
            justifyContent="center"
          >
            No Record Attachments
          </Flex>
        )}

    </VStack>
  );
};

AttachmentsTable.propTypes = { recordId: PropTypes.number.isRequired };

export default AttachmentsTable;
